<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="navg">
          <div class="logo" style="margin-right: 50%;">
            <img src="./assets/test/cb.png" alt />
          </div>
          <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
            :router="router">
            <el-menu-item index="/">{{ $t("message.homemenu1") }}</el-menu-item>
            <el-menu-item index="/service">{{ $t("message.homemenu3") }}</el-menu-item>
            <el-menu-item index="/ca">{{ $t("message.homemenu5") }}</el-menu-item>
            <!-- <el-menu-item index="/market">{{$t("message.homemenu4")}}</el-menu-item> -->
            <el-menu-item index="/about">{{ $t("message.homemenu2") }}</el-menu-item>
            <el-dropdown class="el-dropdown1" @command="handleCommand">
              <span class="el-dropdown-link">{{ $t("message.language") }}<i
                  class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh">中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>{{ $t("message.ctext1") }}</p>
              <span><i class="el-icon-s-promotion"></i> {{ $t("message.ctext2") }}</span>
              <span><i class="el-icon-phone"></i> {{ $t("message.ctext3") }}</span>
              <span><i class="el-icon-s-home"></i> {{ $t("message.ctext4") }} </span>
              <span>
                <br>
                <a href="https://beian.miit.gov.cn" style="color: white;">京ICP备2024069118号</a>
              </span>

            </li>
          </ul>



          <img src="./assets/test/gzh.png" alt />
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        router: true,
        defaultActive: "/",
        isShow: true,
      };
    },
    methods: {
      handleSelect(key) {
        this.isShow = this.defaultActive != key;
        this.isShow = true;

      },
      handleCommand(command) {
        this.$i18n.locale = command
      }
    }
  };
</script>

<style lang="scss">
  * {
    padding: 0;
    margin: 0;
  }

  html,
  body {
    height: 100%;
  }

  .el-menu-demo {
    display: flex;
    padding: 0 3px;
  }

  .navg {
    display: flex;
    width: 100%;
    //border: black solid 1px;
    justify-content: center;

  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;

  }

  .el-dropdown-link {
    cursor: pointer;
    color: #31098f;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    /* 设置父元素高度 */
    //margin-left: 50%;
  }

  .el-icon-arrow-down {
    font-size: 12px;

  }

  .el-header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    margin: 0 auto;
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 999;
    float: right;

    .logo {
      width: 280px;
      padding: 0px;

      margin-right: 600px;

      img {
        width: 100%;
        line-height: 80px;
      }
    }

    //border: red solid 1px;
  }

  .el-main {
    padding: 0 !important;
    //position: absolute;
    //overflow-y: scroll;

  }

  .footer {
    width: 100%;
    height: 216px;
    overflow: hidden;
    //background-color: #14679f;
    background-color: rgb(40, 65, 136);

    &-content {
      width: 1240px;
      margin: 0 auto;
      padding-top: 20px;
      display: flex;
      justify-content: space-between;

      .content-nav {
        display: flex;
        justify-content: space-around;

        li {
          display: flex;
          flex-direction: column;
          padding: 0 20px;
          //justify-content: center;
          align-items: flex-start;

          p {
            font-size: 20px;
            color: #d4edff;
            padding: 10px 0;
          }

          span {
            color: #f7f7f7;
            font-weight: 300;
            padding: 5px 0;
          }
        }
      }

      img {
        width: 170px;
        height: 170px;
        padding: 10px;
      }
    }

    .copyright {
      height: 30px;
      background: #125688;

      span {
        color: #fff;
        line-height: 30px;
      }
    }
  }
</style>
